import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getFreeCourse = courseId => httpClient.get(`${apis.GET_FREE_COURSE}/${courseId}`);
export const addToFavoriteList = payload =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });
